import React, { useEffect, useState } from 'react';
import './TeamManagement.css'; // Link to the styles
import {
  Box,
  Button,
  Flex,
  HStack,
  Text,
} from '@chakra-ui/react';
import { IconButton } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import UsersTab from './TeamManagement/UsersTab';
import GroupsTab from './TeamManagement/GroupsTab';
import apiClient from '../clients/apiClient.js';
import { ChevronRight } from '@mui/icons-material';

function TeamManagement() {
  const [workingTab, setWorkingTab] = useState('users');

  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
  };

  const [teamMembers, setTeamMembers] = useState(null);
  const [teamMembersData, setTeamMembersData] = useState([]);
  const [userTabLoading, setUserTabLoading] = React.useState(false);
  const [groupTabLoading, setGroupTabLoading] = React.useState(false);
  const [groupsData, setGroupsData] = React.useState([]);
  const [groups, setGroups] = React.useState([]);

  useEffect(() => {
    setUserTabLoading(true);
    // Fetch team members data

    apiClient.get('/account-settings/groups').then(({ data }) => {
      setGroups(data.group);
      setGroupsData(data);
      setGroupTabLoading(false);
    });
  }, []);
  
  useEffect(() => {
    setGroupTabLoading(true);
    // Fetch team members data
    
    apiClient.get('/account-settings/team-management').then(({ data }) => {
      setTeamMembers(data.employees_info);
      setTeamMembersData(data);
      setUserTabLoading(false);
    });
  }, []);

  return (
    <Box marginRight={"24px"} h={"100vh"} pl={6}>
      {/* Main Content */}
      <Flex gap={0} mt={6} >
        <Text
          fontSize="16px"
          mb={"8px"}
          lineHeight={"24px"}
          color={'#2584FD'}
          cursor={'pointer'}
          onClick={() => {
            handleNavigate('/account-settings');
          }}
        >
          Settings
        </Text>
        <IconButton
          sx={{
            height: '24px',
            width: '24px',
            padding: 0,
            fontSize: 16,
            color: '#5d5d5d',
            bgcolor: 'transparent',
            '&:hover': {
              backgroundColor: 'transparent',
            },
          }}
        >
          <ChevronRight
            sx={{
              padding: 0,
              fontSize: 16,
              color: '#5d5d5d',
              bgcolor: 'transparent',
            }}
          />
        </IconButton>
      </Flex>
      <HStack
        justifyContent={'space-between'}
      >
        <Text fontSize="24px" lineHeight={"32px"} fontWeight="bold" mb={4} mt={"8px"}>
          Team management
        </Text>
      </HStack>
      <HStack>
        <Button 
          height={"40px"}
          bgColor={workingTab === 'users' ? '#FFFFFF' : 'transparent'}
          borderTop={workingTab === 'users' ? '1px solid #E2E8F0': "1px solid transparent"}
          borderX={workingTab === 'users' ? '1px solid #E2E8F0': "1px solid transparent"}
          _hover={{
            backgroundColor: workingTab === 'users' ? '#FFFFFF' : '#E2E8F0',
          }}
          onClick={() => setWorkingTab('users')}
        >
          <Text fontSize="16px" color="#fffff"> Users </Text>
        </Button>
        <Button
          height={"40px"}
          bgColor={workingTab === 'groups' ? '#FFFFFF' : 'transparent'}
          borderTop={workingTab === 'groups' ? '1px solid #E2E8F0': "1px solid transparent"}
          borderX={workingTab === 'groups' ? '1px solid #E2E8F0': "1px solid transparent"}
          onClick={() => setWorkingTab('groups')}
          _hover={{
            backgroundColor: workingTab === 'groups' ? '#FFFFFF' : '#E2E8F0',
          }}
        >
          <Text fontSize="16px" color="#fffff"> Groups </Text>
        </Button>
      </HStack>
      <Box width="100%" borderBottom="1px solid #E2E8F0" mb={4}></Box>
      {/* // 60 is the Height of topbar */}
      <Box flex="1" overflowY="auto" maxH={`calc(100vh - ${60 + 2*(24 + 32)  + 40}px)`}> 
        {
          workingTab === 'users' && (
            <UsersTab 
              teamMembers={teamMembers}
              setTeamMembers={setTeamMembers}
              loading={userTabLoading}
              teamMembersData={teamMembersData}
            />
          )
        }
        {
          workingTab === 'groups' && (
            <GroupsTab 
              groups={groups}
              setGroups={setGroups}
              loading={groupTabLoading}
              groupsData={groupsData}
              teamMembers={teamMembers}
            />
          )
        }
      </Box>
    </Box>
  );
}

export default TeamManagement;
